export default {"src":"/evde-internet/_next/static/media/mobile-promo.fae73e81.svg","height":187,"width":336};